import { FeatureUse } from "@iventis/domain-model/model/featureUse";
import { ReplayTag, TagValue } from "../tags/tag-types";

export enum MetricEventName {
    MAP_LOADED = "MAP_LOADED",
    SIDEBAR_LOADED = "SIDEBAR_LOADED",
    MAPBOX_LOADED = "MAPBOX_LOADED",
}

export type MetricTags = Partial<Record<ReplayTag, TagValue>>;

export type MetricEvent = {
    name: FeatureUse["name"];
    quantity?: FeatureUse["quantity"];
    resourceId?: FeatureUse["resourceId"];
};
